import { HStack, VStack } from '@chakra-ui/react';
import { Button } from 'Atoms';
import { FolderIllustration, Typography } from 'Tokens';

export const DatapointBrowserBox = ({
  onClickBrowse,
  onClickLearnMore,
}: {
  onClickBrowse: () => void;
  onClickLearnMore: () => void;
}) => {
  return (
    <HStack
      justifyContent="space-between"
      width="100%"
      p="16px"
      borderRadius="8px"
      border="1px solid"
      borderColor="border.decorative"
    >
      <VStack alignItems="start" gap="16px">
        <VStack alignItems="start" gap="2px">
          <Typography variant="h3">Data points database</Typography>
          <Typography variant="body">
            Browse the full library of available data points from other frameworks
          </Typography>
        </VStack>
        <HStack gap="8px">
          <Button variant="secondary" onClick={onClickBrowse}>
            Browse
          </Button>
          <Button variant="ghost" onClick={onClickLearnMore}>
            Learn more
          </Button>
        </HStack>
      </VStack>
      <FolderIllustration boxSize="78px" opacity="50%" />
    </HStack>
  );
};
